var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcontact1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6446)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 120.093,
    x2: 17.9658,
    y2: -21.4222,
    stroke: "url(#paint0_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 120.093,
    x2: 52.9658,
    y2: -21.4222,
    stroke: "url(#paint1_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 120.093,
    x2: 88.9658,
    y2: -21.4222,
    stroke: "url(#paint2_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 120.093,
    x2: 124.966,
    y2: -21.4222,
    stroke: "url(#paint3_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 120.093,
    x2: 160.966,
    y2: -21.4222,
    stroke: "url(#paint4_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 120.093,
    x2: 195.966,
    y2: -21.4222,
    stroke: "url(#paint5_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 120.093,
    x2: 231.966,
    y2: -21.4222,
    stroke: "url(#paint6_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.954,
    x2: 258.387,
    y2: 18.954,
    stroke: "url(#paint7_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.954,
    x2: 258.387,
    y2: 77.954,
    stroke: "url(#paint8_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.954,
    x2: 258.387,
    y2: 47.954,
    stroke: "url(#paint9_linear_75_6446)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_6446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4487 70.991C43.4487 70.239 44.0584 69.6293 44.8105 69.6293H69.3221C70.0742 69.6293 70.6838 70.239 70.6838 70.991C70.6838 71.7431 70.0742 72.3528 69.3221 72.3528H44.8105C44.0584 72.3528 43.4487 71.7431 43.4487 70.991ZM46.1722 60.097C46.1722 59.3449 46.7819 58.7352 47.534 58.7352C48.2861 58.7352 48.8958 59.3449 48.8958 60.097V66.9058C48.8958 67.6578 48.2861 68.2675 47.534 68.2675C46.7819 68.2675 46.1722 67.6578 46.1722 66.9058V60.097ZM52.981 60.097C52.981 59.3449 53.5907 58.7352 54.3428 58.7352C55.0949 58.7352 55.7045 59.3449 55.7045 60.097V66.9058C55.7045 67.6578 55.0949 68.2675 54.3428 68.2675C53.5907 68.2675 52.981 67.6578 52.981 66.9058V60.097ZM58.428 60.097C58.428 59.3449 59.0377 58.7352 59.7898 58.7352C60.5419 58.7352 61.1516 59.3449 61.1516 60.097V66.9058C61.1516 67.6578 60.5419 68.2675 59.7898 68.2675C59.0377 68.2675 58.428 67.6578 58.428 66.9058V60.097ZM65.2368 60.097C65.2368 59.3449 65.8465 58.7352 66.5986 58.7352C67.3507 58.7352 67.9603 59.3449 67.9603 60.097V66.9058C67.9603 67.6578 67.3507 68.2675 66.5986 68.2675C65.8465 68.2675 65.2368 67.6578 65.2368 66.9058V60.097ZM43.4487 53.4227C43.4487 52.5057 43.9668 51.6674 44.787 51.2573L55.9836 45.659C56.6652 45.3182 57.4674 45.3182 58.1489 45.659L69.3456 51.2573C70.1658 51.6674 70.6838 52.5057 70.6838 53.4227V54.9526C70.6838 56.2896 69.6 57.3735 68.2629 57.3735H45.8696C44.5326 57.3735 43.4487 56.2896 43.4487 54.9526V53.4227ZM57.0663 53.2882C57.4274 53.2882 57.7738 53.1447 58.0292 52.8894C58.2846 52.634 58.428 52.2876 58.428 51.9265C58.428 51.5653 58.2846 51.2189 58.0292 50.9635C57.7738 50.7082 57.4274 50.5647 57.0663 50.5647C56.7051 50.5647 56.3588 50.7082 56.1034 50.9635C55.848 51.2189 55.7045 51.5653 55.7045 51.9265C55.7045 52.2876 55.848 52.634 56.1034 52.8894C56.3588 53.1447 56.7051 53.2882 57.0663 53.2882Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-outside-1_75_6446",
    maskUnits: "userSpaceOnUse",
    x: 59.5938,
    y: 55.0936,
    width: 19,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 59.5938,
    y: 55.0936,
    width: 19,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9927 61.1734C64.9927 60.0913 65.4226 59.0537 66.1877 58.2886C66.9527 57.5235 67.9904 57.0936 69.0725 57.0936C70.1545 57.0936 71.1922 57.5235 71.9573 58.2886C72.7224 59.0537 73.1522 60.0913 73.1522 61.1734C73.1522 62.2554 72.7224 63.2931 71.9573 64.0582C71.1922 64.8233 70.1545 65.2531 69.0725 65.2531C67.9904 65.2531 66.9527 64.8233 66.1877 64.0582C65.4226 63.2931 64.9927 62.2554 64.9927 61.1734ZM61.5939 73.961C61.6244 71.9978 62.4258 70.1252 63.825 68.7477C65.2242 67.3701 67.1089 66.598 69.0725 66.598C71.036 66.598 72.9207 67.3701 74.3199 68.7477C75.7191 70.1252 76.5205 71.9978 76.5511 73.961C76.5534 74.0932 76.5172 74.2232 76.4468 74.3351C76.3765 74.447 76.275 74.536 76.1549 74.5911C73.9329 75.6099 71.5168 76.1357 69.0725 76.1324C66.5466 76.1324 64.1469 75.5811 61.99 74.5911C61.8699 74.536 61.7684 74.447 61.6981 74.3351C61.6277 74.2232 61.5915 74.0932 61.5939 73.961Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9927 61.1734C64.9927 60.0913 65.4226 59.0537 66.1877 58.2886C66.9527 57.5235 67.9904 57.0936 69.0725 57.0936C70.1545 57.0936 71.1922 57.5235 71.9573 58.2886C72.7224 59.0537 73.1522 60.0913 73.1522 61.1734C73.1522 62.2554 72.7224 63.2931 71.9573 64.0582C71.1922 64.8233 70.1545 65.2531 69.0725 65.2531C67.9904 65.2531 66.9527 64.8233 66.1877 64.0582C65.4226 63.2931 64.9927 62.2554 64.9927 61.1734ZM61.5939 73.961C61.6244 71.9978 62.4258 70.1252 63.825 68.7477C65.2242 67.3701 67.1089 66.598 69.0725 66.598C71.036 66.598 72.9207 67.3701 74.3199 68.7477C75.7191 70.1252 76.5205 71.9978 76.5511 73.961C76.5534 74.0932 76.5172 74.2232 76.4468 74.3351C76.3765 74.447 76.275 74.536 76.1549 74.5911C73.9329 75.6099 71.5168 76.1357 69.0725 76.1324C66.5466 76.1324 64.1469 75.5811 61.99 74.5911C61.8699 74.536 61.7684 74.447 61.6981 74.3351C61.6277 74.2232 61.5915 74.0932 61.5939 73.961Z",
    fill: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0725 57.0936V55.0936V57.0936ZM69.0725 66.598V68.598V66.598ZM76.5511 73.961L74.5513 73.9922L74.5514 73.9967L76.5511 73.961ZM76.1549 74.5911L76.9884 76.4091L76.9892 76.4088L76.1549 74.5911ZM69.0725 76.1324L69.0752 74.1324H69.0725V76.1324ZM61.99 74.5911L61.1557 76.4088L61.1557 76.4088L61.99 74.5911ZM66.9927 61.1734C66.9927 60.6218 67.2118 60.0928 67.6019 59.7028L64.7734 56.8743C63.6333 58.0145 62.9927 59.5609 62.9927 61.1734H66.9927ZM67.6019 59.7028C67.9919 59.3127 68.5209 59.0936 69.0725 59.0936V55.0936C67.46 55.0936 65.9136 55.7342 64.7734 56.8743L67.6019 59.7028ZM69.0725 59.0936C69.624 59.0936 70.153 59.3127 70.543 59.7028L73.3715 56.8743C72.2313 55.7342 70.6849 55.0936 69.0725 55.0936V59.0936ZM70.543 59.7028C70.9331 60.0928 71.1522 60.6218 71.1522 61.1734H75.1522C75.1522 59.5609 74.5116 58.0145 73.3715 56.8743L70.543 59.7028ZM71.1522 61.1734C71.1522 61.7249 70.9331 62.2539 70.543 62.6439L73.3715 65.4724C74.5116 64.3322 75.1522 62.7858 75.1522 61.1734H71.1522ZM70.543 62.6439C70.153 63.034 69.624 63.2531 69.0725 63.2531V67.2531C70.6849 67.2531 72.2313 66.6125 73.3715 65.4724L70.543 62.6439ZM69.0725 63.2531C68.5209 63.2531 67.9919 63.034 67.6019 62.6439L64.7734 65.4724C65.9136 66.6125 67.46 67.2531 69.0725 67.2531V63.2531ZM67.6019 62.6439C67.2118 62.2539 66.9927 61.7249 66.9927 61.1734H62.9927C62.9927 62.7858 63.6333 64.3322 64.7734 65.4724L67.6019 62.6439ZM63.5936 73.9922C63.616 72.5539 64.2031 71.1821 65.2281 70.1729L62.4218 67.3225C60.6485 69.0684 59.6328 71.4416 59.5941 73.9299L63.5936 73.9922ZM65.2281 70.1729C66.2532 69.1636 67.634 68.598 69.0725 68.598V64.598C66.5839 64.598 64.1951 65.5766 62.4218 67.3225L65.2281 70.1729ZM69.0725 68.598C70.5109 68.598 71.8917 69.1636 72.9168 70.1729L75.7231 67.3225C73.9498 65.5766 71.561 64.598 69.0725 64.598V68.598ZM72.9168 70.1729C73.9418 71.1821 74.5289 72.5539 74.5513 73.9922L78.5508 73.9299C78.5121 71.4416 77.4964 69.0684 75.7231 67.3225L72.9168 70.1729ZM74.5514 73.9967C74.5468 73.7401 74.6171 73.4878 74.7537 73.2705L78.1399 75.3997C78.4173 74.9586 78.56 74.4463 78.5507 73.9254L74.5514 73.9967ZM74.7537 73.2705C74.8903 73.0533 75.0873 72.8805 75.3205 72.7735L76.9892 76.4088C77.4627 76.1914 77.8626 75.8408 78.1399 75.3997L74.7537 73.2705ZM75.3213 72.7731C73.3617 73.6716 71.2309 74.1353 69.0752 74.1324L69.0697 78.1324C71.8027 78.1361 74.5041 77.5482 76.9884 76.4091L75.3213 72.7731ZM69.0725 74.1324C66.8402 74.1324 64.7245 73.6457 62.8244 72.7735L61.1557 76.4088C63.5692 77.5166 66.2531 78.1324 69.0725 78.1324V74.1324ZM62.8244 72.7735C63.0576 72.8805 63.2546 73.0533 63.3912 73.2705L60.005 75.3997C60.2823 75.8408 60.6822 76.1914 61.1557 76.4088L62.8244 72.7735ZM63.3912 73.2705C63.5278 73.4878 63.5981 73.7401 63.5935 73.9967L59.5942 73.9254C59.5849 74.4463 59.7276 74.9586 60.005 75.3997L63.3912 73.2705Z",
    fill: "#F5F8FF",
    mask: "url(#path-14-outside-1_75_6446)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3889 185.848C27.8088 185.848 29.6616 183.75 29.6616 181.473C29.6616 179.285 28.1883 177.924 25.1971 177.388L21.5584 176.763C19.7949 176.383 19.0359 175.959 19.0359 174.664C19.0359 173.325 20.1074 172.655 22.8308 172.655C25.9337 172.655 27.0275 173.571 27.0275 175.401V175.691H29.4161V175.557C29.4161 172.633 27.4293 170.445 23.0541 170.445C18.4109 170.445 16.625 172.633 16.625 174.798C16.625 177.254 18.4109 178.415 20.9334 178.861L24.5943 179.464C26.4918 179.821 27.2508 180.312 27.2508 181.607C27.2508 183.013 26.2462 183.638 23.3889 183.638C20.1074 183.638 19.0582 182.745 19.0582 180.96V180.602H16.6474V180.736C16.6474 183.884 18.9243 185.848 23.3889 185.848ZM34.6323 185.848C37.1548 185.848 38.9183 184.732 39.4987 182.857H39.655V185.625H41.865V178.883C41.865 176.227 40.28 174.307 36.753 174.307C33.226 174.307 31.1276 176.205 31.1276 178.727V178.817H33.5162V178.727C33.5162 177.098 34.5207 176.428 36.5744 176.428C38.6951 176.428 39.4987 177.075 39.4987 178.906V179.553L34.4538 180.089C32.2661 180.334 30.8821 181.227 30.8821 182.946C30.8821 184.777 32.3331 185.848 34.6323 185.848ZM33.293 182.79C33.293 181.919 33.8957 181.629 35.1458 181.473L39.4987 180.982C39.4987 183.169 37.8022 184.107 35.2797 184.107C33.8957 184.107 33.293 183.683 33.293 182.79ZM51.1381 185.625L56.3616 174.53H53.7498L49.7987 183.281H49.6201L45.6689 174.53H43.0125L48.1914 185.625H51.1381ZM60.0092 173.236V170.669H57.5983V173.236H60.0092ZM60.0092 185.625V174.53H57.5983V185.625H60.0092ZM64.6525 185.625V180.134C64.6525 177.723 65.7463 176.473 68.1795 176.473C70.4788 176.473 71.4164 177.522 71.4164 179.598V185.625H73.8272V178.95C73.8272 176.383 72.3093 174.307 69.2287 174.307C66.416 174.307 64.9427 176.093 64.6079 177.968H64.4516V174.53H62.2416V185.625H64.6525ZM80.7972 184.62C83.3197 184.62 84.8154 183.415 85.2172 181.741H85.3734V184.464C85.3734 186.942 84.4582 187.634 81.9357 187.634C79.5695 187.634 78.6319 187.031 78.6319 185.424H76.2434C76.2434 188.103 78.5203 189.643 81.8018 189.643C85.4404 189.643 87.762 188.058 87.762 184.33V174.53H85.552V177.299H85.4181C85.0163 175.356 83.2751 174.307 80.9535 174.307C77.5827 174.307 75.529 176.383 75.529 179.464C75.529 182.544 77.4934 184.62 80.7972 184.62ZM77.9622 179.464C77.9622 177.187 79.3239 176.406 81.6455 176.406C83.9894 176.406 85.3734 177.366 85.3734 179.241V179.553C85.3734 181.518 84.0341 182.544 81.5785 182.544C79.3016 182.544 77.9622 181.741 77.9622 179.464ZM95.2386 185.848C98.3638 185.848 100.418 184.62 100.418 182.544C100.418 180.714 99.2121 179.821 96.578 179.486L94.0108 179.129C92.3366 178.906 91.8902 178.593 91.8902 177.723C91.8902 176.673 92.6045 176.227 94.6359 176.227C97.0914 176.227 97.7611 176.919 97.7611 178.236V178.37H100.15V178.303C100.15 175.669 98.0959 174.307 94.7029 174.307C91.2874 174.307 89.5239 175.691 89.5239 177.633C89.5239 179.486 90.7963 180.379 92.8947 180.647L95.9306 181.049C97.5156 181.272 98.0513 181.562 98.0513 182.477C98.0513 183.46 97.4039 183.906 95.2386 183.906C92.917 183.906 92.0464 183.437 92.0464 181.986V181.808H89.6356V181.875C89.6356 184.442 91.6669 185.848 95.2386 185.848ZM109.231 185.848C111.754 185.848 113.517 184.732 114.097 182.857H114.254V185.625H116.464V178.883C116.464 176.227 114.879 174.307 111.352 174.307C107.825 174.307 105.726 176.205 105.726 178.727V178.817H108.115V178.727C108.115 177.098 109.119 176.428 111.173 176.428C113.294 176.428 114.097 177.075 114.097 178.906V179.553L109.053 180.089C106.865 180.334 105.481 181.227 105.481 182.946C105.481 184.777 106.932 185.848 109.231 185.848ZM107.892 182.79C107.892 181.919 108.494 181.629 109.745 181.473L114.097 180.982C114.097 183.169 112.401 184.107 109.878 184.107C108.494 184.107 107.892 183.683 107.892 182.79ZM124.219 185.848C127.545 185.848 129.978 183.973 129.978 181.205V180.96H127.59V181.116C127.59 182.835 126.34 183.683 124.174 183.683C121.674 183.683 120.558 182.477 120.558 180.089C120.558 177.656 121.674 176.473 124.174 176.473C126.34 176.473 127.59 177.321 127.59 179.04V179.174H129.978V178.95C129.978 176.182 127.545 174.307 124.219 174.307C120.558 174.307 118.169 176.629 118.169 180.089C118.169 183.504 120.558 185.848 124.219 185.848ZM137.364 185.848C140.69 185.848 143.123 183.973 143.123 181.205V180.96H140.735V181.116C140.735 182.835 139.485 183.683 137.319 183.683C134.819 183.683 133.703 182.477 133.703 180.089C133.703 177.656 134.819 176.473 137.319 176.473C139.485 176.473 140.735 177.321 140.735 179.04V179.174H143.123V178.95C143.123 176.182 140.69 174.307 137.364 174.307C133.703 174.307 131.315 176.629 131.315 180.089C131.315 183.504 133.703 185.848 137.364 185.848ZM150.576 185.848C154.282 185.848 156.76 183.504 156.76 180.089C156.76 176.629 154.282 174.307 150.576 174.307C146.893 174.307 144.415 176.629 144.415 180.089C144.415 183.504 146.893 185.848 150.576 185.848ZM150.576 183.705C147.898 183.705 146.781 182.433 146.781 180.089C146.781 177.723 147.898 176.428 150.576 176.428C153.277 176.428 154.394 177.723 154.394 180.089C154.394 182.433 153.277 183.705 150.576 183.705ZM163.13 185.848C165.988 185.848 167.461 184.062 167.818 182.187H167.952V185.625H170.162V174.53H167.773V180.022C167.773 182.433 166.635 183.683 164.179 183.683C161.835 183.683 160.876 182.634 160.876 180.558V174.53H158.487V181.205C158.487 183.772 160.005 185.848 163.13 185.848ZM174.763 185.625V180.134C174.763 177.723 175.857 176.473 178.29 176.473C180.589 176.473 181.527 177.522 181.527 179.598V185.625H183.938V178.95C183.938 176.383 182.42 174.307 179.339 174.307C176.527 174.307 175.053 176.093 174.718 177.968H174.562V174.53H172.352V185.625H174.763ZM193.363 185.625V183.46H191.354C189.97 183.46 189.345 183.103 189.345 181.741V176.54H193.363V174.53H189.345V172.097H186.957V174.53H185.081V176.54H186.957V181.875C186.957 184.576 188.43 185.625 190.818 185.625H193.363ZM22.7862 212.848C26.4918 212.848 28.9696 210.504 28.9696 207.089C28.9696 203.629 26.4918 201.307 22.7862 201.307C19.1029 201.307 16.625 203.629 16.625 207.089C16.625 210.504 19.1029 212.848 22.7862 212.848ZM22.7862 210.705C20.1074 210.705 18.9913 209.433 18.9913 207.089C18.9913 204.723 20.1074 203.428 22.7862 203.428C25.4873 203.428 26.6034 204.723 26.6034 207.089C26.6034 209.433 25.4873 210.705 22.7862 210.705ZM33.1301 216.42V209.5H33.2194C33.6658 211.531 35.2731 212.848 37.7732 212.848C41.2333 212.848 43.1308 210.527 43.1308 207.089C43.1308 203.651 41.1887 201.307 37.7509 201.307C35.1391 201.307 33.5765 202.557 33.1301 204.611H32.9292V201.53H30.7192V216.42H33.1301ZM33.1301 207.267V207.067C33.1301 204.678 34.5141 203.517 36.9919 203.517C39.3135 203.517 40.7199 204.41 40.7199 207.089C40.7199 209.745 39.3359 210.661 36.9473 210.661C34.5811 210.661 33.1301 209.544 33.1301 207.267ZM50.3826 212.848C53.6864 212.848 56.008 211.219 56.008 208.852V208.652H53.5971V208.83C53.5971 210.147 52.6372 210.906 50.3156 210.906C47.7485 210.906 46.6993 209.768 46.61 207.625H56.0303C56.0972 207.29 56.1196 206.977 56.1196 206.575C56.1196 203.205 53.7757 201.307 50.3379 201.307C46.7216 201.307 44.3554 203.629 44.3554 207.089C44.3554 210.795 46.7439 212.848 50.3826 212.848ZM50.2933 203.205C52.6595 203.205 53.8426 204.187 53.8426 206.241V206.285H46.6323C46.7663 204.299 47.8378 203.205 50.2933 203.205ZM60.3362 212.625V207.134C60.3362 204.723 61.43 203.473 63.8632 203.473C66.1625 203.473 67.1 204.522 67.1 206.598V212.625H69.5109V205.95C69.5109 203.383 67.9929 201.307 64.9124 201.307C62.0997 201.307 60.6264 203.093 60.2915 204.968H60.1353V201.53H57.9253V212.625H60.3362ZM74.07 200.236V197.669H71.6591V200.236H74.07ZM74.07 212.625V201.53H71.6591V212.625H74.07ZM78.7134 212.625V207.134C78.7134 204.723 79.8072 203.473 82.2404 203.473C84.5396 203.473 85.4772 204.522 85.4772 206.598V212.625H87.8881V205.95C87.8881 203.383 86.3701 201.307 83.2896 201.307C80.4769 201.307 79.0036 203.093 78.6687 204.968H78.5124V201.53H76.3025V212.625H78.7134ZM94.8581 211.62C97.3806 211.62 98.8762 210.415 99.278 208.741H99.4343V211.464C99.4343 213.942 98.519 214.634 95.9965 214.634C93.6303 214.634 92.6928 214.031 92.6928 212.424H90.3042C90.3042 215.103 92.5811 216.643 95.8626 216.643C99.5013 216.643 101.823 215.058 101.823 211.33V201.53H99.6129V204.299H99.4789C99.0771 202.356 97.3359 201.307 95.0143 201.307C91.6436 201.307 89.5899 203.383 89.5899 206.464C89.5899 209.544 91.5543 211.62 94.8581 211.62ZM92.0231 206.464C92.0231 204.187 93.3848 203.406 95.7063 203.406C98.0503 203.406 99.4343 204.366 99.4343 206.241V206.553C99.4343 208.518 98.0949 209.544 95.6394 209.544C93.3624 209.544 92.0231 208.741 92.0231 206.464Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6446",
    x1: 18.4658,
    y1: -1.34432,
    x2: 18.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6446",
    x1: 53.4658,
    y1: -1.34432,
    x2: 53.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6446",
    x1: 89.4658,
    y1: -1.34432,
    x2: 89.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6446",
    x1: 125.466,
    y1: -1.34432,
    x2: 125.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6446",
    x1: 161.466,
    y1: -1.34432,
    x2: 161.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6446",
    x1: 196.466,
    y1: -1.34432,
    x2: 196.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6446",
    x1: 232.466,
    y1: -1.34432,
    x2: 232.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6446",
    x1: 0,
    y1: 19.454,
    x2: 255.154,
    y2: 19.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6446",
    x1: 0,
    y1: 78.454,
    x2: 255.154,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6446",
    x1: 0,
    y1: 48.454,
    x2: 255.154,
    y2: 48.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6446",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6446",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6446"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_6446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(39 39.625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcontact1);
export default __webpack_public_path__ + "static/media/bigcontact1.bd3547114d20e4650e1f7b9878536b64.svg";
export { ForwardRef as ReactComponent };